import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedName from 'I18n/components/FormattedName';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Flex } from 'foundations-components/components/Flex';
import AgentAvatar from '../../shared/components/AgentAvatar';
import OwnerActivationStatusTag from './OwnerActivationStatusTag';
import ReassignmentSelectInputPlaceholder from './ReassignmentSelectInputPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentValueButton = ({
  AsyncUIAvatar,
  avatar,
  away,
  email,
  firstName,
  lastName,
  loading,
  responder,
  text
}) => {
  const showPlaceholder = loading || !responder && text;
  if (showPlaceholder) return /*#__PURE__*/_jsx(ReassignmentSelectInputPlaceholder, {});
  const renderOwnerNameWithActivationTag = status => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedName, {
        givenName: firstName !== null && firstName !== void 0 ? firstName : undefined,
        familyName: lastName !== null && lastName !== void 0 ? lastName : undefined,
        email: email !== null && email !== void 0 ? email : undefined
      }), /*#__PURE__*/_jsx(OwnerActivationStatusTag, {
        activationStatus: status
      })]
    });
  };
  const renderOwnerName = () => {
    return responder ? renderOwnerNameWithActivationTag(responder.activationStatus) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "routing-ui.reassignment.noOwnerUserOption"
    });
  };
  return /*#__PURE__*/_jsx(MediaObject, {
    align: "center",
    spacing: "extra-small",
    itemLeft: /*#__PURE__*/_jsx(AgentAvatar, {
      AsyncUIAvatar: AsyncUIAvatar,
      avatar: avatar,
      away: away,
      showStatus: Boolean(responder),
      size: "sm"
    }),
    children: /*#__PURE__*/_jsx(Flex, {
      flexWrap: "nowrap",
      "data-test-id": "reassignment-selected-agent",
      children: renderOwnerName()
    })
  });
};
ReassignmentValueButton.displayName = 'ReassignmentValueButton';
export default ReassignmentValueButton;